const Revenue = [
    {
        id: 1,
        value: 'Just getting started',
        backendValue: {
            min: 0,
            max: 0
        }
    },
    {
        id: 2,
        value: '$1K - $10K',
        backendValue: {
            min: 1000,
            max: 10000
        }
    },
    {
        id: 3,
        value: '$10K - $100K',
        backendValue: {
            min: 10000,
            max: 100000
        }
    },
    {
        id: 4,
        value: '$100K - $500K',
        backendValue: {
            min: 100000,
            max: 500000
        }
    },
    {
        id: 5,
        value: '$500K - $1M',
        backendValue: {
            min: 500000,
            max: 1000000
        }
    },
    {
        id: 6,
        value: '$1M - $5M',
        backendValue: {
            min: 1000000,
            max: 5000000
        }
    },
    {
        id: 7,
        value: '$5M - $10M',
        backendValue: {
            min: 5000000,
            max: 10000000
        }
    },
    {
        id: 8,
        value: '$10M - $50M',
        backendValue: {
            min: 10000000,
            max: 50000000
        }
    },
    {
        id: 9,
        value: '$50M - $100M',
        backendValue: {
            min: 50000000,
            max: 100000000
        }
    },
    {
        id: 10,
        value: '$100M - $500M',
        backendValue: {
            min: 100000000,
            max: 500000000
        }
    },
    {
        id: 11,
        value: '$500M - $1B',
        backendValue: {
            min: 500000000,
            max: 1000000000
        }
    },
    {
        id: 12,
        value: '$1B+',
        backendValue: {
            min: 1000000000,
            max: 0
        }
    }
];

export default Revenue;